import { Extension } from "@tiptap/core";
import { type CoreExtensionNames } from "../constants/extention";

type TActiveDropbarExtensions = CoreExtensionNames.MENTION;

declare module "@tiptap/core" {
  interface Commands {
    utility: unknown;
  }
}

export interface UtilityExtensionStorage {
  activeDropbarExtensions: TActiveDropbarExtensions[];
  isTouchDevice: boolean;
}

interface UtilityExtensionProps {
  isEditable: boolean;
  isTouchDevice: boolean;
}

export const UtilityExtension = (props: UtilityExtensionProps) => {
  const { isTouchDevice } = props;

  return Extension.create<Record<string, unknown>, UtilityExtensionStorage>({
    name: "utility",
    priority: 1000,

    addStorage() {
      return { activeDropbarExtensions: [], isTouchDevice };
    }
  });
};
